module.exports = __webpack_public_path__ + "static/peppers-menu-inside-fd598a6c7f6b5a53a3617ad13b6de0ee.jpg";